export const OFFER_REQUEST_SELECTED = `sellerOfferRequests/OFFER_REQUEST_SELECTED`
export const OPEN_OFFER_REQUEST_UPDATED = `sellerOfferRequests/OFFER_REQUEST_UPDATED`
